import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

/**
 * Full-page loading and error states, so no route ever renders a blank screen
 * (PRD NFR-U5). Loading is announced politely; errors assertively.
 */
export function LoadingScreen({ label }: { label: string }) {
  return (
    <main className="flex min-h-screen items-center justify-center p-4">
      <output aria-live="polite" className="flex items-center gap-3 text-muted-foreground">
        <Spinner className="h-5 w-5" />
        {label}
      </output>
    </main>
  );
}

export function ErrorScreen({ message, onRetry }: { message: string; onRetry: () => void }) {
  const { t } = useTranslation('common');
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
      <p role="alert" className="max-w-md text-center">
        {message}
      </p>
      <Button onClick={onRetry} autoFocus>
        {t('errors.retry')}
      </Button>
    </main>
  );
}
